const path = 'redux/Property';
export const PROPERTIES_LOADED = `${path}/PROPERTIES_LOADED`;
export const LOADING_PROPERTIES = `${path}/LOADING_PROPERTIES`;
export const GET_QOUTE = `${path}/GET_QOUTE`;
export const QOUTE_LOADED = `${path}/QOUTE_LOADED`;
export const PROPERTY_LOADED = `${path}/PROPERTY_LOADED`;
export const LOADING_PROPERTY = `${path}/LOADING_PROPERTY `;
export const FAVORITES_LOADED = `${path}/FAVORITES_LOADED`;
export const IDS_LOADED = `${path}/IDS_LOADED`;
export const LOADING_FAVORITES = `${path}/LOADING_FAVORITES`;
export const LOADING_IDS = `${path}/LOADING_IDS`;
export const TOGGLE_SELECTED_PROPERTY = `${path}/TOGGLE_SELECTED_PROPERTY`;
export const CLEAR_PROPERTIES = `${path}/CLEAR_PROPERTIES`;
export const LOADING_RESERVATION_REPORTS = `${path}/LOADING_RESERVATION_REPORTS`;
export const RESERVATION_REPORTS_LOADED = `${path}/RESERVATION_REPORTS_LOADED`;
export const VALID_SEARCH_DESTINATION_CHECK = `${path}/VALID_SEARCH_DESTINATION_CHECK`;
export const FLAG_WISHLIST_MODEL = `${path}/FLAG_WISHLIST_MODEL`;
export const UPDATE_SEARCH_VALUES = `${path}/UPDATE_SEARCH_VALUES`;
export const UPDATE_SEARCH_PARAMS = `${path}/UPDATE_SEARCH_PARAMS`;
export const UPDATE_SHOWINMAPSEARCH = `${path}/UPDATE_SHOWINMAPSEARCH`;
export const UPDATE_PROPERTY_FROM_LINK = `${path}/UPDATE_PROPERTY_FROM_LINK`;
export const INTERACTIVE_MAP_LOCATION = `${path}/INTERACTIVE_MAP_LOCATION`;
export const INTERACTIVE_MAP_LISTINGS = `${path}/INTERACTIVE_MAP_LISTINGS`;
export const INTERACTIVE_MAP_POINTS = `${path}/INTERACTIVE_MAP_POINTS`;
export const INTERACTIVE_MAP_LISTINGS_LOADING = `${path}/INTERACTIVE_MAP_LISTINGS_LOADING`;
export const INTERACTIVE_MAP_POINTS_LOADING = `${path}/INTERACTIVE_MAP_POINTS_LOADING`;
export const INTERACTIVE_MAP_SELECTED_CONTINENT = `${path}/INTERACTIVE_MAP_SELECTED_CONTINENT`;
export const INTERACTIVE_MAP_LAST_VIEWED_COUNTRY = `${path}/INTERACTIVE_MAP_LAST_VIEWED_COUNTRY`;
export const SET_SELECTED_LISTING = `${path}/SET_SELECTED_LISTING`;
export const UPDATE_LATEST_PROPERTIES = `${path}/UPDATE_LATEST_PROPERTIES`;
export const RESET_LATEST_PROPERTIES = `${path}/RESET_LATEST_PROPERTIES`;
export const SET_INTERACTIVE_MAP_CONTINENT_COUNTRIES = `${path}/SET_INTERACTIVE_MAP_CONTINENT_COUNTRIES`;
export const SET_ALL_ACTIVE_COUNTRIES = `${path}/SET_ALL_ACTIVE_COUNTRIES`;

// Group accommodation mode
export const SET_GROUP_MODE = `${path}/SET_GROUP_MODE`;
export const SET_GROUP_FILTERS = `${path}/SET_GROUP_FILTERS`;
export const LOADING_CLUSTERS = `${path}/LOADING_CLUSTERS`;
export const CLUSTERS_LOADED = `${path}/CLUSTERS_LOADED`;
export const CLUSTERS_FAILED = `${path}/CLUSTERS_FAILED`;
export const LOAD_MORE_CLUSTERS = `${path}/LOAD_MORE_CLUSTERS`;
export const RESET_CLUSTERS = `${path}/RESET_CLUSTERS`;
export const CLUSTERS_CANCELLED = `${path}/CLUSTERS_CANCELLED`;
export const CLUSTER_QUOTES_VERIFIED = `${path}/CLUSTER_QUOTES_VERIFIED`;
// Search-card live-price overlay: patch calculatedPrice/totalprice in place for the
// listings whose live quote came back positive (see overlayLiveSearchPrices). Never
// carries a non-positive price — the thunk drops those so a card keeps its stored value.
export const PATCH_LIVE_SEARCH_PRICES = `${path}/PATCH_LIVE_SEARCH_PRICES`;
